export const isExperienceAvailable = (
  experience: App.ExperienceOffer,
  viewAsTemplate = false,
) => {
  return experience.status === 'ONLINE' || viewAsTemplate
}
